import ajax from "../utils/request";
const animationApi = {
  /********************************动漫列表*********************************** */
  // 获取动漫列表
  getAnimeList(params) {
    return ajax({
      url: "/media/list",
      type: "get",
      params: params,
    });
  },
  // 添加动漫
  addAnime(params) {
    return ajax({
      url: "/media/create",
      type: "post",
      params: params,
    });
  },
  // 删除动漫
  delAnime(params) {
    return ajax({
      url: "/media/delete",
      type: "post",
      params: params,
    });
  },
  // 修改动漫
  updateAnime(params) {
    return ajax({
      url: "/media/update",
      type: "post",
      params: params,
    });
  },
  // 动漫导出
  exportMediaList(params) {
    return ajax({
      url: "/media/export",
      type: "post",
      responseType: "blob",
      params: params,
    });
  },
  // 批量删除动漫列表
  batchDelMedia(params) {
    return ajax({
      url: "/media/batch/delete",
      type: "post",
      params: params,
    });
  },
  batchUpdatePrice(params) {
    return ajax({
      url: '/media/batch/updateMedia',
      type: "post",
      params: params,
    })
  },
  /********************************动漫推荐列表*********************************** */
  // 获取动漫推荐列表
  getMediaRecommendList(params) {
    return ajax({
      url: "/media_recommend/list",
      type: "get",
      params: params,
    });
  },
  // 添加动漫推荐
  addMediaRecommend(params) {
    return ajax({
      url: "/media_recommend/create",
      type: "post",
      params: params,
    });
  },
  // 删除动漫推荐
  delMediaRecommend(params) {
    return ajax({
      url: "/media_recommend/delete",
      type: "post",
      params: params,
    });
  },
  // 修改动漫推荐
  updateMediaRecommend(params) {
    return ajax({
      url: "/media_recommend/update",
      type: "post",
      params: params,
    });
  },
  // 获取动漫推荐信息
  getMediaRecommendInfo(params) {
    return ajax({
      url: "/media_recommend/info",
      type: "get",
      params: params,
    });
  },
  /********************************动漫任务列表*********************************** */
  // 获取动漫任务列表
  getMediaTaskList(params) {
    return ajax({
      url: "/media_task/list",
      type: "get",
      params: params,
    });
  },
  // 添加动漫任务
  addMediaTask(params) {
    return ajax({
      url: "/media_task/create",
      type: "post",
      params: params,
    });
  },
  // 删除动漫任务
  delMediaTask(params) {
    return ajax({
      url: "/media_task/delete",
      type: "post",
      params: params,
    });
  },
  // 修改动漫任务
  updateMediaTask(params) {
    return ajax({
      url: "/media_task/update",
      type: "post",
      params: params,
    });
  },
  /********************************动漫上传列表*********************************** */
  // 视频上传
  uploadMedia(params) {
    return ajax({
      url: "/media/create",
      type: "post",
      params: params,
    });
  },
  // 子媒体上传
  subUploadMedia(params) {
    return ajax({
      url: "/media_content/create",
      type: "post",
      params: params,
    });
  },
  // 校验媒体是否存在
  getMediaInfo(params) {
    return ajax({
      url: "/media/find",
      type: "get",
      params: params,
    });
  },
  // 获取种类、维度下的标签
  getMediaTagByKindDimension(params) {
    return ajax({
      url: "/media_tag/all",
      type: "get",
      params: params,
    });
  },
  // 设置媒体状态
  setMediaStatus(params) {
    return ajax({
      url: "/media/batch/update",
      type: "post",
      params: params,
    });
  },
  // 获取动漫专题
  queryModuleCartoonAll(params) {
    return ajax({
      url: "/module/conf/cartoon/all",
      type: "get",
      params: params,
    });
  },
  /********************************动漫内容列表*********************************** */
  // 获取动漫内容列表
  getAnimeContentList(params) {
    return ajax({
      url: "/media_content/list",
      type: "get",
      params: params,
    });
  },
  // 添加动漫内容
  addAnimeContent(params) {
    return ajax({
      url: "/media_content/create",
      type: "post",
      params: params,
    });
  },
  // 删除动漫内容
  delAnimeContent(params) {
    return ajax({
      url: "/media_content/delete",
      type: "post",
      params: params,
    });
  },
  // 修改动漫内容
  updateAnimeContent(params) {
    return ajax({
      url: "/media_content/update",
      type: "post",
      params: params,
    });
  },
  // 修改动漫内容
  setSubMediaStatus(params) {
    return ajax({
      url: "/media_content/batch/update",
      type: "post",
      params: params,
    });
  },
  /********************************动漫标签列表*********************************** */
  // 获取动漫标签列表
  getAnimeTagList(params) {
    return ajax({
      url: "/media_tag/list",
      type: "get",
      params: params,
    });
  },
  // 获取动漫所有维度
  getAnimeAllLatitude(params) {
    return ajax({
      url: "/media_tag_dimension/all",
      type: "get",
      params: params,
    });
  },
  // 添加动漫标签
  addAnimeTag(params) {
    return ajax({
      url: "/media_tag/create",
      type: "post",
      params: params,
    });
  },
  // 删除动漫标签
  delAnimeTag(params) {
    return ajax({
      url: "/media_tag/delete",
      type: "post",
      params: params,
    });
  },
  // 修改动漫标签
  updateAnimeTag(params) {
    return ajax({
      url: "/media_tag/update",
      type: "post",
      params: params,
    });
  },
  /********************************维度列表*********************************** */
  // 获取维度列表
  getLatitudeList(params) {
    return ajax({
      url: "/media_tag_dimension/list",
      type: "get",
      params: params,
    });
  },
  // 添加维度
  addLatitude(params) {
    return ajax({
      url: "/media_tag_dimension/create",
      type: "post",
      params: params,
    });
  },
  // 删除维度
  delLatitude(params) {
    return ajax({
      url: "/media_tag_dimension/delete",
      type: "post",
      params: params,
    });
  },
  // 修改维度
  updateLatitude(params) {
    return ajax({
      url: "/media_tag_dimension/update",
      type: "post",
      params: params,
    });
  },
  /***********************acg媒体资源库************************ */
  // 查询acg媒体资源库列表
  queryAcgMediaResConfig(params) {
    return ajax({
      url: "/mediaResource/media/list",
      type: "get",
      params: params,
    });
  },
  // 查询acg媒体资源库列表(子)
  queryAcgMediaContentResConfig(params) {
    return ajax({
      url: "/mediaResource/media/content_list",
      type: "get",
      params: params,
    });
  },
  // acg媒体使用
  useAcgMediaRes(params) {
    return ajax({
      url: "/mediaResource/media/use",
      type: "post",
      params: params,
    });
  },
  // acg媒体使用
  ignoreAcgMediaRes(params) {
    return ajax({
      url: "/mediaResource/media/ignore",
      type: "post",
      params: params,
    });
  },
  // acg媒体同步
  acgMediaSync(params) {
    return ajax({
      url: "/mediaResource/media/sync",
      type: "post",
      params: params,
    });
  },
};
export default animationApi;
